import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

function PreferencesAPI(): BringozApi {
  return {
    base : `/settings/preferences`
  }
}
angular
  .module('bringoz.admin.site-preferences')
  .factory('PreferencesAPI', PreferencesAPI);
